export const EXERCISES_DOMAIN = 'exercises'
